import React from 'react';
import { QuizOption } from '../../types';

interface ChapterSelectionProps {
  subjectId: string;
  chapterOptions: QuizOption[];
  selectedChapters: string[];
  loadingChapters: boolean;
  isSubjectFullySelected: (subjectId: string) => boolean;
  isSubjectPartiallySelected: (subjectId: string) => boolean;
  onChapterChange: (chapterId: string) => void;
  onSelectAllChapters: (subjectId: string, checked: boolean) => void;
}

const ChapterSelection: React.FC<ChapterSelectionProps> = ({
  subjectId,
  chapterOptions,
  selectedChapters,
  loadingChapters,
  isSubjectFullySelected,
  isSubjectPartiallySelected,
  onChapterChange,
  onSelectAllChapters
}) => {
  const subjectChapters = chapterOptions.filter(ch => ch.subject_id?.toString() === subjectId);

  return (
    <div className="mt-3 pt-3 border-top">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h6 className="fw-semibold mb-0 text-secondary">
          <i className="fas fa-bookmark me-1"></i>
          Chapters
        </h6>
        {loadingChapters ? (
          <span className="spinner-border spinner-border-sm"></span>
        ) : (
          subjectChapters.length > 0 && (
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={`select-all-chapters-${subjectId}`}
                checked={isSubjectFullySelected(subjectId)}
                ref={(input) => {
                  if (input) input.indeterminate = isSubjectPartiallySelected(subjectId);
                }}
                onChange={(e) => onSelectAllChapters(subjectId, e.target.checked)}
              />
              <label className="form-check-label small text-muted" htmlFor={`select-all-chapters-${subjectId}`}>
                Select All
              </label>
            </div>
          )
        )}
      </div>
      
      {loadingChapters ? (
        <div className="text-center py-2">
          <small className="text-muted">Loading chapters...</small>
        </div>
      ) : (
        <div className="row g-1">
          {subjectChapters.map(chapter => (
            <div key={chapter.value} className="col-12 col-md-4">
              <div className="border rounded-2 p-2 h-100" style={{ backgroundColor: '#ffffff' }}>
                <div className="d-flex align-items-center justify-content-between h-100">
                  <div className="form-check flex-grow-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`chapter-${chapter.value}`}
                      checked={selectedChapters.includes(chapter.value)}
                      onChange={() => onChapterChange(chapter.value)}
                    />
                    <label className="form-check-label small ms-2" htmlFor={`chapter-${chapter.value}`}>
                      {chapter.label}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {subjectChapters.length === 0 && !loadingChapters && (
        <p className="text-muted small mb-0">No chapters available for this subject.</p>
      )}
    </div>
  );
};

export default ChapterSelection;